import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
// const getProductDetailUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-product-detail`;
// const getAdditionalProductDetailUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-additional-product-detail`;
// const getProdcutAdditionalInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/catalog/get-product-additional-info`;


const getProductDetailUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-product-detail`;
const getAdditionalProductDetailUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-additional-product-detail`;
const getProdcutAdditionalInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/catalog/get-product-additional-info`;


const addProductDetailRequested = () => ({
  type: types.ADD_PRODUCT_DETAIL_REQUEST
});
const addProductDetailSuccess = data => ({
  type: types.ADD_PRODUCT_DETAIL_SUCCESS,
  data
});
const addProductDetailFailure = error => ({
  type: types.ADD_PRODUCT_DETAIL_FAILURE,
  error
});

// Actions
const productDetailRequested = () => ({
    type: types.PRODUCT_DETAIL_REQUEST
  });

const productDetailSuccess = data => ({
    type: types.PRODUCT_DETAIL_SUCCESS,
    data
  });

const productAddtionalInfoSuccess = info => ({
    type: types.PRODUCT_ADDITIONAL_INFO_SUCCESS,
    info
  });
    
const productDetailFailure = error => ({
    type: types.PRODUCT_DETAIL_FAILURE,
    error
  });

// API
export const getProductDetail =  ({lot_code,
   connection_id, size_id, color_id, product_id,purity_id, user_logged_in_store_id,tenant_name}) => {
    return async dispatch => {
try {
      dispatch(productDetailRequested());
     const response = await axios.get(getProductDetailUrl, {
        params: {
          connection_id,
          lot_code,
          size_id,
          color_id,
          product_id,
          purity_id,
          tenant_name
          
         // user_logged_in_store_id
        },
      }).then(res=>res.data);
        
          if (response.ack === "Success") {
            dispatch(productDetailSuccess(response.results));
            return "success"
          
         
          } else if (response.ack === "Failure") {
            toast.error(`Failed - ${response.status.message}`);
            dispatch(productDetailFailure(response.status));
            return "success"

          } 
          
      
        }
      
        catch(err){
          dispatch(productDetailFailure(err));
          return "failed"



        }
    };
  };

  export const getAdditionalProductDetail = (options) => {
    return async dispatch => {
      try {
      dispatch(addProductDetailRequested());
    const response = await axios.get(getAdditionalProductDetailUrl, {
        params: {
          connection_id:options.connection_id,
          lot_code : options.lot_code,
          tenant_name : options.tenant_name
         
        },
      }).then(res=>res.data);
        
          if (response.ack === "Success") {


            dispatch(addProductDetailSuccess(response.results));
          } else if (response.ack === "Failure") {
            toast.error(`Failed - ${response.status.message}`);
            dispatch(addProductDetailFailure(response.status));
          } 

    }
        catch(err) {
          dispatch(addProductDetailFailure(err));
          
        };
    };
  };

  export const getProductAddnInfo = (options) => {
    return dispatch => {
      dispatch(productDetailRequested());
      axios.get(getProdcutAdditionalInfoUrl, {
        params: {
          connection_id: options.connection_id,
          product_code: options.product_code,
          category_code: options.category_code
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(productAddtionalInfoSuccess(res.data.results));
          } else if (res.data.ack === "Failure") {
            toast.error(`Failed - ${res.data.status.message}`);
            dispatch(productDetailFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };